<template>
  <div class="fillheight">
    <div v-show="loadingBar" class="pace">
      <div class="pace-progress">
        <div class="progress">
          <div class="indeterminate"></div>
        </div>
      </div>
      <div class="pace-activity"></div>
    </div>
    <loading-container location="main" style="height:100vh">
      <router-view />
    </loading-container>
    <notifications group="notify" position="top center">
      <template slot="body" slot-scope="props">
        <div class="notification" :class="props.item.type">
          <div class="left">
            <v-icon v-if="props.item.type == 'success'">mdi-check-circle</v-icon>
            <v-icon v-if="props.item.type == 'error'">mdi-alert</v-icon>
          </div>
          <div class="right">
            <a class="title">{{ props.item.title }}</a>
            <div v-if="isString(props.item)">
              <ul>
                <li v-for="(item, index) of props.item.text" :key="index">
                  <template v-if="item.text">
                    <span :class="`${item.type}--text`" v-html="item.text"></span>
                  </template>
                  <template v-else>
                    <span v-html="item"></span>
                  </template>
                </li>
              </ul>
            </div>
            <div v-else v-html="props.item.text"></div>
          </div>
          <div>
            <a class="close" @click="props.close">
              <v-icon>mdi-close</v-icon>
            </a>
          </div>
        </div>
      </template>
    </notifications>
    <notifications group="progress" position="bottom left" />
    <BoxUpload />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import BoxUpload from './components/QueueUpload/BoxUpload.vue';
export default {
  components: { BoxUpload },
  computed: {
    ...mapGetters({
      loadingBar: 'loading/loadingBar',
    }),
  },
  data: () => ({}),
  mounted() {
    // this.$root.$confirm = this.$refs.confirm.open
    // initConfirm(this.$refs.confirm.open)
  },
  methods: {
    isString(item) {
      return typeof item.text != 'string'
    },
  },
}
</script>
